import type { JobType } from "@/utils/jobsPublic";

export const APPLICANT_DOCUMENT_MAX_BYTES = 4 * 1024 * 1024;
export const APPLICANT_DOCUMENT_MAX_COUNT = 3;

export function applicantJobQueryString(job: {
  type: JobType;
  id: string;
}): string {
  const params = new URLSearchParams({
    type: job.type,
    jobId: job.id,
  });
  return params.toString();
}
